




import Vue from 'vue';
import CardAcceptanceSettings from '../../../common/components/support/CardAcceptanceSettings.vue';

export default Vue.extend({
  components: {
    CardAcceptanceSettings,
  },
});
